import React from "react";
import { PaPageHeader } from "components/platform-admin";
import EventsManager from "components/FeedEvents/EventsManager";
import { canManageDashboardEvents } from "components/FeedEvents/feedEvents.utils";
import PlatformAdminLayout from "pages/PlatformAdmin/layout/PlatformAdminLayout";
import PaAccessDenied from "pages/PlatformAdmin/layout/PaAccessDenied";

const EventsAdmin = () => {
  const canManage = canManageDashboardEvents();

  if (!canManage) {
    return (
      <PaAccessDenied
        title="Events"
        description="Only Super Admin / Catalog staff with platform news permission can manage events."
      />
    );
  }

  return (
    <PlatformAdminLayout>
      <PaPageHeader
        title="Events"
        subtitle="Post events with a picture and formatted text. They appear in the Events tab on every organization's dashboard."
      />
      <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:p-6">
        <EventsManager canManage adminList />
      </div>
    </PlatformAdminLayout>
  );
};

export default EventsAdmin;
